import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Icon, Table } from 'semantic-ui-react';
import { MarketingData } from '../../../../types/MarketingData';
import { MarketingDataModalComponent } from '../../../misc/MarketingDataModal.component';

type LeadMarketingDataProps = {
    marketingData: MarketingData | undefined;
};

export default function LeadMarketingDataComponent(props: LeadMarketingDataProps): React.ReactElement {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header>{t('lead.detail.box.marketingData.headline')}</Card.Header>
                <Card.Description>
                    <Table celled striped columns={2}>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={4}>{t(`lead.detail.box.marketingData.partner`)}</Table.Cell>
                                <Table.Cell singleLine>
                                    {(props.marketingData?.type && (
                                        <>
                                            {props.marketingData?.type}
                                            <Icon
                                                name="info circle"
                                                style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
                                                onClick={() => {
                                                    setShowModal(true);
                                                }}
                                            />
                                        </>
                                    )) ||
                                        'n/a'}
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
            {props.marketingData && (
                <MarketingDataModalComponent
                    showModal={showModal}
                    onClose={() => setShowModal(false)}
                    data={props.marketingData}
                />
            )}
        </Card>
    );
}
